import { Injectable } from "@angular/core";

@Injectable()
export class ObjectHelpers {
    /**
     * Converts an array to a key value pair object with a specific key;
     * @param array Array to convert
     * @param keyPredicate Function that returns the property to be used as a Key
     * @example 
     * array = [{id: 1, value: 'as', name: 'joao'}, {id: 2, value: 'cd', name: 'joana'}];
     * result = mapArrayToObjectWithSpecificValue(array, (obj) => obj.name, (obj) => obj.value);
     * result: { 
     *  'joao': {id: 1, value: 'as', name: 'joao'},
     *  'joana': {id: 2, value: 'cd', name: 'joana'} 
     * }
    */
    static mapArrayToObject<T, K extends keyof T>(
        array: T[],
        keyPredicate: (obj: T) => K
    ): {[key: string]: T} {
    return array.reduce((acc, item) => {
        let key = String(keyPredicate.call(null, item));
        acc[key] = item;
        return acc;
    }, {} as {[key: string]: T});
    }


    /**
     * Converts an array to a key value pair object where the value is a specific property;
     * @param array Array to convert
     * @param keyPredicate Function that returns the property to be used as a Key
     * @param valuePredicate Function that returns the property to be used as a Value
     * @example 
     * array = [{id: 1, value: 'as', name: 'joao'}, {id: 2, value: 'cd', name: 'joana'}];
     * result = mapArrayToObjectWithSpecificValue(array, (obj) => obj.name, (obj) => obj.value);
     * result: { 
     *  'joao': 'as',
     *  'joana': 'cd'
     * }
    */
    static mapArrayToObjectWithSpecificValue<T, K extends keyof T, V>(
        array: T[],
        keyPredicate: (obj: T) => K,
        valuePredicate: (obj: T) => V
    ): Record<string, V> {
    return array.reduce((acc, item) => {
        let value = valuePredicate.call(null, item);
        let key = String(keyPredicate.call(null, item));
        acc[key] = value;

        return acc;
    }, {} as Record<string, V>);
    }
}